import styled from 'styled-components'

import BootstrapModalTitle from 'react-bootstrap/lib/ModalTitle'

export const ModalDescription = styled(BootstrapModalTitle)`
  font-size: 18px;
  text-align: center;
  margin-top: 20px;
  color: ${props => props.theme.colors.ebonyClay};
  opacity: 0.87;
  line-height: 20px;
  pointer-events: none;
`
